@if (value(); as current) { @if (current.type === 'transaction') {
<span class="transaction">
    <p-icon name="info" size="sm"></p-icon>
    <span>{{ current.code }}</span>
</span>
} @else {
<span class="text">{{ current.text }}</span>
} } @else {
<span class="empty">{{ 'aichat.canvas.draft.entity.empty_value' | translate }}</span>
}
